if (!window.customElements.get('add-to-wishlist-data-layer-button')) {
    class AddToWishlistDataLayerButton extends HTMLElement {
        constructor() {
            super();
            this.submitButtonElement = this.querySelector('[data-add-to-wishlist-submit-button]');
            /* Lancel : tuiles copiees dans le panneau mobile -> pas d'erreur si les donnees manquent */
            const customerInfo = document.querySelector('[data-wishlist-customer-info]');
            const productInfo = this.querySelector('[data-product-info-for-wishlist]');
            if (!this.submitButtonElement || !customerInfo || !productInfo) return;
            this.currentCustomerData = JSON.parse(customerInfo.textContent);
            this.jsonData = JSON.parse(productInfo.textContent);

            this.submitButtonElement.addEventListener('click',this.onSubmitButtonClick.bind(this));
        }

        isProductInWishlist(selectedProduct, selectedVariant){
            if (window.iWish) {
                const result = window.iWish.isInWishlist(selectedVariant.id.toString());
                return result;
            }
            return false;
        }
        getSelectedProduct() {
            return this.jsonData.product;
        }
        getSelectedVariant() {
            const variantsDictionary = this.jsonData.variants;
            const selecteVariantId = this.querySelector('[data-product]').dataset.variant;
            const selectedVariant = variantsDictionary.filter(variant => variant.id == selecteVariantId);

            if (selectedVariant.length){
                return selectedVariant[0];
            }

            return {};
        }
        onSubmitButtonClick(event) {

            const selectedProduct = this.getSelectedProduct();
            const selectedVariant = this.getSelectedVariant();

            if (!this.isProductInWishlist(selectedProduct, selectedVariant)) {
                window.dataLayer = window.dataLayer || [];

                const payload = {
                    "event": "add_to_wishlist_stape",
                    "actual_url": window.location.href,
                    "ecomm_pagetype": this.getPageType(),
                    ...this.currentCustomerData,
                    "ecommerce": {
                        "value": selectedVariant?.price / 100,
                        "currency": this.currentCustomerData.currency,
                        "items": [{
                            "item_id": selectedProduct?.id,
                            "item_sku": selectedVariant?.sku,
                            "item_variant": selectedVariant?.id,
                            "item_name": selectedProduct?.title,
                            "variant_name": selectedVariant?.title,
                            "item_category": selectedProduct?.type,
                            "price": selectedVariant?.price / 100,
                            "item_brand": selectedProduct?.vendor,
                            "imageURL": selectedVariant?.featured_image ?? selectedProduct?.featured_image,
                            "item_url": selectedProduct?.url,
                            "quantity": "1"
                        }]
                    }
                }
                window.dataLayer.push(payload);
            }
        }

        getPageType() {

            let path = window.location?.pathname;
            
            if (path.includes('/collection')) { return 'category'; }
            else if (path.includes('/product')) { return 'product'; }
            else if (path.includes('/cart')) { return 'basket'; }
            else if (path === '/') { return 'home'; }
            else if (path.includes('thank_you') || path.includes('thank-you')) { return 'purchase'; }  
            else if (path.includes('/checkout')) { return 'basket'; }
            else { return 'other'; }

        }
    }
    customElements.define('add-to-wishlist-data-layer-button', AddToWishlistDataLayerButton);
}

/* =====================================================================
   LANCEL (oct. 2026)
   1. Emballage cadeau (Wrapped) :
      - chaque clic est pris en compte instantanement (case + TOTAL), meme en
        rafale sur plusieurs articles : les choix sont mis en file et envoyes a
        Wrapped l'un apres l'autre, sans que rien ne saute a l'ecran ;
      - copie d'attente identique (meme case, meme coche) pendant que Wrapped
        redessine ses rectangles ;
      - pas de rechargement, pas de retour en haut ; pastilles sans emballage.
   2. TELEPHONE : panneau "Shopping bag" (contenu de la page panier).
   3. Bulle de discussion masquee sans chevauchement pendant les panneaux.
   4. Carrousel "Vous aimerez aussi" : fleches (2 produits par clic, defilement doux).
   5. Ordi : titre du panneau "Mon panier" plus discret.
   ===================================================================== */
(function () {
  var GIFT_HANDLE = 'gift-wrapping';
  var MQ_PHONE = window.matchMedia('(max-width: 749px)');
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function onCartPage() { return /\/cart\/?$/.test(window.location.pathname); }

  /* ---------- Styles globaux ---------- */
  var css = [
    '.mini-cart_item > .lc-mc-gift{flex-basis:calc(100% + 5px)!important;width:calc(100% + 5px)!important;margin-right:-5px!important;}',
    '.mini-cart_item-meta .color{display:none!important;}',
    '.mini-cart_item.lc-mc-technical{display:none!important;}',
    '.giftbox-container{position:relative;display:flow-root;}',
    '.giftbox-container.giftbox-container > wrapped-extension{margin:0!important;}',
    '.giftbox-container > wrapped-extension:not([hidden]):not([data-lc-ready]){visibility:hidden!important;position:absolute!important;top:0!important;left:0!important;right:0!important;}',
    '.giftbox-container:has(> wrapped-extension:not([hidden])),.giftbox-container:has(> .lc-gift-ph){min-height:56px;}',
    '.lc-gift-ph{position:absolute;top:0;left:0;right:0;height:56px;display:flex;align-items:center;gap:12px;padding:8px 16px;border:1px solid #e1e1e1;background:#fff;box-sizing:border-box;cursor:pointer;z-index:1;-webkit-tap-highlight-color:transparent;}',
    '.lc-gift-ph.is-on{border-color:#181818;}',
    '.lc-gift-ph__box{display:block;flex:0 0 16px;width:16px;height:16px;border:1px solid #000;border-radius:.9px;box-sizing:border-box;background:#fff;}',
    '.lc-gift-ph__box svg{display:block;width:100%;height:100%;opacity:0;}',
    '.lc-gift-ph__box path{fill:none;stroke:#fff;stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round;}',
    '.lc-gift-ph.is-on .lc-gift-ph__box{background:#000;}',
    '.lc-gift-ph.is-on .lc-gift-ph__box svg{opacity:1;}',
    '.lc-gift-ph__label{flex:0 1 auto;min-width:0;font-size:11px;font-weight:400;letter-spacing:.1em;text-transform:uppercase;line-height:1.4;color:#181818;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
    '.lc-gift-ph__img{flex:0 0 40px;width:40px;height:40px;margin:0 auto;object-fit:cover;display:block;}',
    '.lc-gift-ph__price{flex:0 0 auto;margin-left:auto;font-size:13px;font-weight:400;letter-spacing:.02em;color:#181818;white-space:nowrap;}',
    '.lc-gift-ph__img ~ .lc-gift-ph__price{margin-left:0;}',
    'html.lc-chat-hold #launcher,html.lc-chat-hold div:has(> iframe[title*="messaging window"]),html.lc-chat-hold div[id^="widget-chat-button-"]{display:none!important;}',
    'body:not(:has(#MainContent #main-cart-items)) div[id^="widget-chat-button-"]{opacity:1!important;visibility:visible!important;pointer-events:auto!important;}',
    '@media screen and (min-width:1024px){#shopify-section-header .header-cart-modal .header-account-modal-title{font-family:inherit!important;font-size:1.4rem!important;font-weight:400!important;line-height:1.5!important;letter-spacing:.16em!important;text-transform:uppercase!important;padding-bottom:2.4rem!important;margin:0!important;}}',
    '@media screen and (max-width:749px){',
    '.header-cart-modal{display:none!important;}',
    '#lc-bag{position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483000;visibility:hidden;pointer-events:none;transition:visibility 0s linear .4s;}',
    '#lc-bag.is-open{visibility:visible;pointer-events:auto;transition:visibility 0s linear 0s;}',
    '#lc-bag .lc-bag__panel{position:absolute;top:0;right:0;bottom:0;left:0;background:#fff;transform:translate3d(100%,0,0);transition:transform .4s cubic-bezier(.32,.72,0,1);will-change:transform;overflow-y:auto;overflow-x:hidden;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;overflow-anchor:none;}',
    '#lc-bag.is-open .lc-bag__panel{transform:translate3d(0,0,0);}',
    '#lc-bag.no-anim .lc-bag__panel{transition:none;}',
    '#lc-bag .lc-bag__loading{display:flex;align-items:center;justify-content:center;min-height:60vh;}',
    '#lc-bag .lc-bag__loading:after{content:"";width:2.4rem;height:2.4rem;border:1px solid #e1e1e1;border-top-color:#181818;border-radius:50%;animation:lcBagSpin .8s linear infinite;}',
    '@keyframes lcBagSpin{to{transform:rotate(360deg);}}',
    '#lc-bag cart-items{margin-top:0!important;padding-top:2.4rem!important;}',
    '#lc-bag .lc-cart-close{display:flex!important;}',
    '}'
  ].join('\n');
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  /* ==========================================================
     1. Emballage cadeau (Wrapped)
     ========================================================== */
  function disableWrappedReload() {
    var opt = window.Wrapped && window.Wrapped.options;
    if (opt) {
      Object.keys(opt).forEach(function (k) {
        (opt[k].blocks || []).forEach(function (b) { b.refresh = false; });
      });
    }
    document.querySelectorAll('.giftbox-container > wrapped-extension').forEach(function (h) {
      if (h.block) h.block.refresh = false;
    });
  }
  disableWrappedReload();

  var giftPending = false;
  var replaying = false;
  var queue = [];
  function setBusy(v) { giftPending = v; window.lcGiftBusy = v || queue.length > 0; }

  var giftTxt = null;
  try { giftTxt = JSON.parse(sessionStorage.getItem('lcGiftTxt') || 'null'); } catch (e) {}
  function saveGiftTxt(label, price) {
    if (!label || !price) return;
    if (giftTxt && giftTxt.label === label && giftTxt.price === price) return;
    giftTxt = { label: label, price: price };
    try { sessionStorage.setItem('lcGiftTxt', JSON.stringify(giftTxt)); } catch (e) {}
  }

  var L = ':host(wrapped-extension) gift-block-launcher [data-part="container"][data-part="container"] label';
  var WRAPPED_CSS = [
    ':host{display:block!important;width:100%!important;max-width:none!important;padding:0!important;}',
    'wrapped-preset{display:block!important;width:100%!important;max-width:none!important;margin:0!important;padding:0!important;border:0!important;border-radius:0!important;background:none!important;box-shadow:none!important;}',
    'wrapped-basic-mode,wrapped-advanced-mode,gift-block-launcher{display:block!important;width:100%!important;max-width:none!important;margin:0!important;padding:0!important;border:0!important;}',
    ':host(wrapped-extension) gift-block-launcher [data-part="container"][data-part="container"]{display:block!important;width:100%!important;max-width:none!important;margin:0!important;padding:0!important;border:0!important;box-sizing:border-box!important;}',
    L + '{display:flex!important;flex-wrap:nowrap!important;align-items:center!important;gap:12px!important;width:100%!important;max-width:none!important;height:56px!important;min-height:56px!important;box-sizing:border-box!important;margin:0!important;padding:8px 16px!important;border:1px solid #e1e1e1!important;border-radius:0!important;background:#fff!important;cursor:pointer!important;-webkit-tap-highlight-color:transparent;}',
    L + ':has(input:checked){border-color:#181818!important;}',
    '@media (hover:hover){' + L + ':hover{border-color:#181818!important;}}',
    L + ' > svg{position:static!important;flex:0 0 16px!important;width:16px!important;height:16px!important;margin:0!important;}',
    L + ' > span[data-part="label"]{flex:0 1 auto!important;min-width:0!important;margin:0!important;padding:0!important;font-family:inherit!important;font-size:11px!important;font-weight:400!important;letter-spacing:.1em!important;text-transform:uppercase!important;line-height:1.4!important;color:#181818!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}',
    L + ' > .lc-thumb{flex:0 0 40px!important;width:40px!important;height:40px!important;margin:0 auto!important;object-fit:cover;display:block!important;}',
    L + ' > span[data-part="thumbnail"]{display:none!important;}',
    L + ' > span[data-part="pricing"]{flex:0 0 auto!important;margin:0 0 0 auto!important;padding:0!important;font-family:inherit!important;font-size:13px!important;font-weight:400!important;letter-spacing:.02em!important;color:#181818!important;white-space:nowrap!important;}',
    L + ' > .lc-thumb ~ span[data-part="pricing"]{margin-left:0!important;}'
  ].join('\n');

  function hostChecked(host) {
    var i = host && host.shadowRoot && host.shadowRoot.querySelector('gift-block-launcher input');
    return i ? i.checked : null;
  }

  var PH_BOX = '<span class="lc-gift-ph__box"><svg viewBox="4.75 4.75 10.5 10.5" aria-hidden="true"><path d="M7.5 10 9.25 11.75 12.75 8.25"></path></svg></span>';

  function ensurePlaceholder(c) {
    var state = c.getAttribute('data-lc-gift');
    var ph = c.querySelector(':scope > .lc-gift-ph');
    var host = c.querySelector(':scope > wrapped-extension');
    var ready = host && host.hasAttribute('data-lc-ready') && !host.hasAttribute('hidden');
    var hidden = host && host.hasAttribute('hidden');
    if (!state || state === 'none' || (hidden && c.hasAttribute('data-lc-auto') && !giftPending && !queue.length)) {
      if (ph) ph.remove();
      return;
    }
    var hc = hostChecked(host);
    var matches = ready && (hc === null || hc === (state === 'on'));
    if (matches) {
      if (ph) ph.remove();
      return;
    }
    if (!ph) {
      ph = document.createElement('div');
      ph.className = 'lc-gift-ph';
      ph.setAttribute('aria-hidden', 'true');
      var holder = c.closest('[data-gift-img]');
      var img = (holder && holder.getAttribute('data-gift-img')) || '';
      ph.innerHTML = PH_BOX + '<span class="lc-gift-ph__label"></span>' +
        (img ? '<img class="lc-gift-ph__img" alt="">' : '') + '<span class="lc-gift-ph__price"></span>';
      ph.querySelector('.lc-gift-ph__label').textContent = (giftTxt && giftTxt.label) || c.getAttribute('data-gift-label') || '';
      ph.querySelector('.lc-gift-ph__price').textContent = (giftTxt && giftTxt.price) || c.getAttribute('data-gift-price-text') || '';
      if (img) ph.querySelector('img').src = img;
      c.appendChild(ph);
    }
    ph.classList.toggle('is-on', state === 'on');
  }

  function decorateHost(host) {
    var r = host.shadowRoot;
    if (!r) return;
    if (host.block) host.block.refresh = false;
    if (!host.__lcVars) {
      host.__lcVars = true;
      ['--shadow-block-margin-start', '--shadow-block-margin-block-start',
       '--shadow-block-margin-end', '--shadow-block-margin-block-end'].forEach(function (v) {
        host.style.setProperty(v, '0px');
      });
    }
    if (!r.querySelector('style[data-lc]')) {
      var s = document.createElement('style');
      s.setAttribute('data-lc', '');
      s.textContent = WRAPPED_CSS;
      r.appendChild(s);
    }
    var c = host.parentElement;
    var holder = host.closest('[data-gift-img]');
    var img = holder && holder.getAttribute('data-gift-img');
    var labels = r.querySelectorAll('gift-block-launcher label');
    labels.forEach(function (label) {
      if (img && !label.querySelector('.lc-thumb')) {
        var pricing = label.querySelector('span[data-part="pricing"]');
        var t = document.createElement('img');
        t.className = 'lc-thumb';
        t.src = img;
        t.alt = '';
        t.setAttribute('aria-hidden', 'true');
        if (pricing) label.insertBefore(t, pricing); else label.appendChild(t);
      }
      var lt = label.querySelector('span[data-part="label"]');
      var pt = label.querySelector('span[data-part="pricing"]');
      if (lt && pt) saveGiftTxt(lt.textContent.trim(), pt.textContent.trim());
      var input = label.querySelector('input');
      if (!giftPending && !queue.length && input && c && c.getAttribute('data-lc-gift') && c.getAttribute('data-lc-gift') !== 'none') {
        c.setAttribute('data-lc-gift', input.checked ? 'on' : 'off');
      }
      if (input && !input.__lcWatch) {
        input.__lcWatch = true;
        input.addEventListener('change', function () { if (c) ensurePlaceholder(c); });
      }
    });
    if (labels.length && !host.hasAttribute('data-lc-ready')) host.setAttribute('data-lc-ready', '');
    if (c && c.classList.contains('giftbox-container')) ensurePlaceholder(c);
    if (!r.__lcObserved && 'MutationObserver' in window) {
      r.__lcObserved = true;
      new MutationObserver(function () { decorateHost(host); }).observe(r, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked'] });
    }
  }
  function decorateAll() {
    reapplyQueue();
    document.querySelectorAll('.giftbox-container').forEach(function (c) {
      var h = c.querySelector(':scope > wrapped-extension');
      if (h && h.shadowRoot) decorateHost(h); else ensurePlaceholder(c);
    });
  }
  var decoratePending = false;
  function scheduleDecorate() {
    if (decoratePending) return;
    decoratePending = true;
    Promise.resolve().then(function () { decoratePending = false; decorateAll(); });
  }
  window.lcDecorateWrapped = scheduleDecorate;

  function formatLike(text, cents) {
    var m = text.match(/\d[\d\s.,\u00a0\u202f]*\d|\d/);
    if (!m) return text;
    var num = m[0];
    var dec = /[.,]\d{2}$/.test(num) ? num.charAt(num.length - 3) : null;
    var thouMatch = (dec ? num.slice(0, -3) : num).match(/\d([.,\s\u00a0\u202f])\d{3}/);
    var thou = thouMatch ? thouMatch[1] : (dec === ',' ? '.' : ',');
    var parts = (Math.max(0, cents) / 100).toFixed(2).split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    return text.replace(num, intPart + (dec ? dec + parts[1] : ''));
  }
  function centsOf(text) {
    var m = text.match(/\d[\d\s.,\u00a0\u202f]*\d|\d/);
    if (!m) return null;
    var num = m[0];
    var hasDec = /[.,]\d{2}$/.test(num);
    var digits = num.replace(/\D/g, '');
    return hasDec ? parseInt(digits, 10) : parseInt(digits, 10) * 100;
  }
  function bumpTotals(c, delta) {
    var scope = c.closest('#main-cart-items');
    if (scope) {
      var t = scope.querySelector('.lc-total-value');
      if (t) {
        var cur = parseInt(t.getAttribute('data-total'), 10);
        if (isNaN(cur)) cur = centsOf(t.textContent);
        if (cur !== null) {
          t.setAttribute('data-total', cur + delta);
          t.textContent = formatLike(t.textContent.trim(), cur + delta);
        }
      }
    }
    if (c.closest('.header-cart-modal')) {
      var d = document.getElementById('total-price_minicart');
      if (d) {
        var dc = centsOf(d.textContent);
        if (dc !== null) {
          var nt = formatLike(d.textContent.trim(), dc + delta);
          d.__lcLast = nt;
          d.textContent = nt;
        }
      }
    }
  }

  function scopeOf(c) {
    if (c.closest('#lc-bag')) return 'bag';
    if (c.closest('#MainContent')) return 'page';
    if (c.closest('.header-cart-modal')) return 'drawer';
    return null;
  }
  function listContainers(scope) {
    var r = scope === 'bag' ? document.getElementById('lc-bag') :
            scope === 'page' ? document.getElementById('MainContent') :
            document.querySelector('.header-cart-modal');
    if (!r) return [];
    return Array.prototype.filter.call(r.querySelectorAll('.giftbox-container'), function (c) {
      var s = c.getAttribute('data-lc-gift');
      return s && s !== 'none';
    });
  }
  function queueToggle(c) {
    var state = c.getAttribute('data-lc-gift');
    if (!state || state === 'none') return;
    var scope = scopeOf(c);
    var idx = listContainers(scope).indexOf(c);
    if (idx < 0) return;
    var desired = state === 'on' ? 'off' : 'on';
    var price = parseInt(c.getAttribute('data-gift-price'), 10) || 0;
    var q = null;
    for (var i = 0; i < queue.length; i++) if (queue[i].scope === scope && queue[i].idx === idx) q = queue[i];
    if (!q) { q = { scope: scope, idx: idx, base: state, price: price }; queue.push(q); }
    q.desired = desired;
    if (q.desired === q.base) queue.splice(queue.indexOf(q), 1);
    c.setAttribute('data-lc-gift', desired);
    ensurePlaceholder(c);
    if (price) bumpTotals(c, desired === 'on' ? price : -price);
    setBusy(giftPending);
  }
  function reapplyQueue() {
    queue.forEach(function (q) {
      var c = listContainers(q.scope)[q.idx];
      if (!c || c.getAttribute('data-lc-gift') === q.desired) return;
      c.setAttribute('data-lc-gift', q.desired);
      ensurePlaceholder(c);
      if (q.price && q.scope !== 'drawer') bumpTotals(c, q.desired === 'on' ? q.price : -q.price);
    });
  }
  window.lcAfterCartRender = function () { reapplyQueue(); decorateAll(); };
  function drawerQueuedDelta() {
    return queue.reduce(function (s, q) {
      return s + (q.scope === 'drawer' && q.desired !== q.base ? (q.desired === 'on' ? q.price : -q.price) : 0);
    }, 0);
  }
  function watchDrawerTotal() {
    var el = document.getElementById('total-price_minicart');
    if (!el || el.__lcObs || !('MutationObserver' in window)) return;
    el.__lcObs = true;
    new MutationObserver(function () {
      var t = el.textContent.trim();
      if (t === el.__lcLast) return;
      var d = drawerQueuedDelta();
      if (!d) return;
      var c = centsOf(t);
      if (c === null) return;
      var nt = formatLike(t, c + d);
      el.__lcLast = nt;
      el.textContent = nt;
    }).observe(el, { childList: true, characterData: true, subtree: true });
  }
  function processQueue() {
    if (giftPending) return;
    while (queue.length) {
      var q = queue[0];
      var c = listContainers(q.scope)[q.idx];
      if (!c) { queue.shift(); continue; }
      var host = c.querySelector(':scope > wrapped-extension');
      var ready = host && host.hasAttribute('data-lc-ready') && !host.hasAttribute('hidden');
      var actual = hostChecked(host);
      if (!ready || actual === null) { setTimeout(processQueue, 150); return; }
      if ((q.desired === 'on') === actual) { queue.shift(); continue; }
      var input = host.shadowRoot.querySelector('gift-block-launcher input');
      queue.shift();
      replaying = true;
      try { input.click(); } finally { replaying = false; }
      return;
    }
    setBusy(false);
    scheduleDecorate();
  }

  function presync(c, now) {
    var row = c.closest('tr.cart-item');
    var drawerItem = c.closest('.mini-cart_item');
    if (now === 'on') {
      if (row) {
        var tbody = row.parentElement;
        var tr = document.createElement('tr');
        tr.className = 'cart-item lc-row-technical lc-row-pending';
        tr.setAttribute('aria-hidden', 'true');
        tr.innerHTML = '<td class="cart-item__details" colspan="3"><div class="lc-gift-row"><div class="giftbox-container" data-lc-gift="none"></div></div></td>';
        tbody.insertBefore(tr, tbody.querySelector('tr.cart-item'));
      } else if (drawerItem) {
        var first = document.querySelector('.header-cart-modal .mini-cart_item');
        var d = document.createElement('div');
        d.className = 'mini-cart_item flex-row lc-mc-technical lc-row-pending';
        d.setAttribute('aria-hidden', 'true');
        d.innerHTML = '<div class="giftbox-container lc-mc-gift" data-lc-gift="none"></div>';
        if (first) first.parentNode.insertBefore(d, first);
      }
    } else {
      var b = c.getAttribute('data-bundle');
      var scope = row ? row.parentElement : document.querySelector('.header-cart-modal');
      if (!scope) return;
      var sel = row ? 'tr.lc-row-technical' : '.mini-cart_item.lc-mc-technical';
      var removed = false;
      if (b) {
        scope.querySelectorAll(sel).forEach(function (t) { if (!removed && t.getAttribute('data-bundle') === b) { t.remove(); removed = true; } });
      }
      if (!removed) {
        var pend = scope.querySelector(sel + '.lc-row-pending');
        if (pend) pend.remove();
      }
    }
  }

  function articleCount(cart) {
    return cart.items.reduce(function (n, i) { return n + (i.handle === GIFT_HANDLE ? 0 : i.quantity); }, 0);
  }
  function setCounts(n) {
    var els = document.getElementsByClassName('cartItemsNumber');
    for (var i = 0; i < els.length; i++) els[i].innerText = n;
  }
  function getCart() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function refreshCounts() {
    return getCart().then(function (c) { setCounts(articleCount(c)); annotateDrawer(c); return c; }).catch(function () {});
  }
  function signature(cart) {
    return cart.items.map(function (i) {
      var p = i.properties || {};
      return i.key + ':' + i.quantity + ':' + (p['Gift Wrap'] || '');
    }).join('|');
  }

  var giftUnitPrice = null;
  function annotateDrawer(cart) {
    var items = document.querySelectorAll('.header-cart-modal .mini-cart_item');
    if (!items.length || items.length !== cart.items.length) return;
    cart.items.forEach(function (it, i) {
      var el = items[i];
      var p = it.properties || {};
      if (p['_Wrapped Bundle']) el.setAttribute('data-bundle', p['_Wrapped Bundle']);
      if (it.handle === GIFT_HANDLE) { giftUnitPrice = it.price; el.classList.add('lc-mc-technical'); }
      var c = el.querySelector('.giftbox-container');
      if (!c || c.hasAttribute('data-lc-gift')) return;
      c.setAttribute('data-lc-auto', '');
      c.setAttribute('data-lc-gift', it.handle === GIFT_HANDLE ? 'none' : (p['Gift Wrap'] === 'yes' ? 'on' : 'off'));
      if (p['_Wrapped Bundle']) c.setAttribute('data-bundle', p['_Wrapped Bundle']);
      if (giftUnitPrice) c.setAttribute('data-gift-price', giftUnitPrice * it.quantity);
    });
    if (!giftUnitPrice) {
      fetch(root() + 'products/gift-wrapping.js').then(function (r) { return r.json(); }).then(function (p) {
        giftUnitPrice = p.price;
        document.querySelectorAll('.header-cart-modal .giftbox-container[data-lc-auto]:not([data-gift-price])').forEach(function (c) {
          c.setAttribute('data-gift-price', giftUnitPrice);
        });
      }).catch(function () {});
    }
  }

  function cleanOrphans(cart) {
    if (onCartPage()) return Promise.resolve(false);
    var linked = {};
    cart.items.forEach(function (i) {
      var p = i.properties || {};
      if (i.handle !== GIFT_HANDLE && p['Gift Wrap'] === 'yes' && p['_Wrapped Bundle']) linked[p['_Wrapped Bundle']] = true;
    });
    var orphans = cart.items.filter(function (i) {
      return i.handle === GIFT_HANDLE && !linked[(i.properties || {})['_Wrapped Bundle']];
    });
    if (!orphans.length) return Promise.resolve(false);
    var updates = {};
    orphans.forEach(function (i) { updates[i.key] = 0; });
    return fetch(root() + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () { return true; }, function () { return false; });
  }

  function minicartScroller() {
    return document.querySelector('.header-cart-modal #mini-cart_items > .mini-cart_items-container');
  }
  function refreshMinicart() {
    var sc = minicartScroller();
    var keepY = sc ? sc.scrollTop : 0;
    var keepWin = window.scrollY;
    var list = document.querySelector('.header-cart-modal #mini-cart_items');
    var restore = function () {
      var s2 = minicartScroller();
      if (s2 && s2.scrollTop !== keepY) s2.scrollTop = keepY;
      if (Math.abs(window.scrollY - keepWin) > 1) window.scrollTo(0, keepWin);
    };
    var mo = null;
    if (list && 'MutationObserver' in window) {
      mo = new MutationObserver(restore);
      mo.observe(list, { childList: true });
    }
    return fetch(root() + '?sections=mini-cart', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        window.product = window.product || {};
        window.product.sections = window.product.sections || {};
        if (data && data['mini-cart']) window.product.sections['mini-cart'] = data['mini-cart'];
        document.dispatchEvent(new CustomEvent('show-minicart', { detail: { showmodal: false } }));
      })
      .then(function () {
        setTimeout(function () { restore(); if (mo) mo.disconnect(); }, 1500);
      });
  }

  function refreshCartViews() {
    var jobs = [];
    if (document.querySelector('#main-cart-items') && typeof window.lcCartRefresh === 'function') {
      jobs.push(window.lcCartRefresh());
    }
    if (!onCartPage() && document.querySelector('.header-cart-modal')) {
      jobs.push(refreshMinicart().then(function () {
        if (window.Wrapped && typeof window.Wrapped.buildExtensions === 'function') return window.Wrapped.buildExtensions(true);
      }));
    }
    return Promise.all(jobs).catch(function () {}).then(function () {
      bagDirty = false;
      return refreshCounts();
    });
  }

  var watching = false;
  function watchGiftToggle() {
    if (watching) return;
    watching = true;
    setBusy(true);
    getCart().then(function (start) {
      var s0 = signature(start);
      var tries = 0;
      var last = null;
      return new Promise(function (resolve) {
        (function poll() {
          tries++;
          setTimeout(function () {
            getCart().then(function (c) {
              var s = signature(c);
              if (s !== s0 && s === last) return resolve(true);
              last = s;
              if (tries >= 16) return resolve(s !== s0);
              poll();
            }, function () { if (tries >= 16) resolve(false); else poll(); });
          }, tries === 1 ? 250 : 350);
        })();
      });
    }).then(function (changed) {
      if (changed) return refreshCartViews();
    }).catch(function () {}).then(function () {
      watching = false;
      setBusy(false);
      if (queue.length) { window.lcGiftBusy = true; setTimeout(processQueue, 450); }
      else scheduleDecorate();
    });
  }

  document.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    var input = null;
    var c = null;
    var onPh = false;
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (!input && n && n.tagName === 'INPUT' && n.type === 'checkbox') input = n;
      if (n && n.classList && n.classList.contains('lc-gift-ph')) onPh = true;
      if (n && n.classList && n.classList.contains('giftbox-container')) { c = n; break; }
    }
    if (!c) return;
    disableWrappedReload();

    if (replaying) {
      if (input) {
        setBusy(true);
        presync(c, input.checked ? 'on' : 'off');
        bagDirty = true;
        setTimeout(watchGiftToggle, 0);
      }
      return;
    }

    if (onPh || giftPending || queue.length) {
      if (!onPh && !input) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      queueToggle(c);
      if (!giftPending) { window.lcGiftBusy = true; setTimeout(processQueue, 0); }
      return;
    }

    if (!input) return;
    var was = c.getAttribute('data-lc-gift');
    var now = input.checked ? 'on' : 'off';
    if (was && was !== 'none' && was !== now) {
      setBusy(true);
      c.setAttribute('data-lc-gift', now);
      presync(c, now);
      var price = parseInt(c.getAttribute('data-gift-price'), 10);
      if (!isNaN(price) && price > 0) bumpTotals(c, now === 'on' ? price : -price);
    }
    bagDirty = true;
    setTimeout(watchGiftToggle, 0);
  }, true);

  /* ==========================================================
     2. TELEPHONE : panneau "Shopping bag"
     ========================================================== */
  var bag = null;
  var bagLoaded = false;
  var bagLoading = null;
  var bagDirty = false;
  var scrollY0 = 0;

  (function trackCartWrites() {
    var re = /\/cart\/(add|change|update|clear)|cartLines|cartAttributes|cartNote/;
    var origFetch = window.fetch;
    if (origFetch && !origFetch.__lc) {
      var wrapped = function (input, init) {
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var body = init && typeof init.body === 'string' ? init.body : '';
          if (re.test(url) || re.test(body)) bagDirty = true;
        } catch (e) {}
        return origFetch.apply(this, arguments);
      };
      wrapped.__lc = true;
      window.fetch = wrapped;
    }
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      try { if (re.test(String(url))) bagDirty = true; } catch (e) {}
      return origOpen.apply(this, arguments);
    };
  })();

  function ensureBag() {
    if (bag) return bag;
    bag = document.createElement('div');
    bag.id = 'lc-bag';
    bag.setAttribute('aria-hidden', 'true');
    bag.innerHTML = '<div class="lc-bag__panel" role="dialog" aria-modal="true"><div class="lc-bag__body"><div class="lc-bag__loading"></div></div></div>';
    document.body.appendChild(bag);
    return bag;
  }

  function unlazy(scope) {
    scope.querySelectorAll('img[data-src], img[data-srcset]').forEach(function (img) {
      if (img.dataset.srcset && !img.getAttribute('srcset')) img.setAttribute('srcset', img.dataset.srcset);
      if (img.dataset.src && !img.getAttribute('src')) img.setAttribute('src', img.dataset.src);
      img.classList.remove('lazyload');
      img.classList.add('lazyloaded');
      if (img.getAttribute('srcset') && !img.getAttribute('sizes')) img.setAttribute('sizes', '50vw');
    });
  }

  function loadScript(src) {
    return new Promise(function (resolve) {
      if (document.querySelector('script[data-lc-src="' + src + '"]')) return resolve();
      var s = document.createElement('script');
      s.src = src;
      s.setAttribute('data-lc-src', src);
      s.onload = s.onerror = function () { resolve(); };
      document.body.appendChild(s);
    });
  }

  function loadBag() {
    if (bagLoaded) return Promise.resolve();
    if (bagLoading) return bagLoading;
    ensureBag();
    bagLoading = fetch(root() + 'cart', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var main = doc.getElementById('MainContent');
        if (!main || !main.querySelector('#main-cart-items')) throw new Error('panier introuvable');
        var srcs = [];
        main.querySelectorAll('script[src]').forEach(function (s) {
          var src = s.getAttribute('src');
          if (/\/assets\/cart\.js/.test(src)) srcs[0] = src;
          if (/\/assets\/lc-cart-mobile\.js/.test(src)) srcs[1] = src;
        });
        main.querySelectorAll('script').forEach(function (s) { s.remove(); });
        unlazy(main);
        bag.querySelector('.lc-bag__body').innerHTML = main.innerHTML;
        decorateAll();
        var chain = Promise.resolve();
        if (srcs[0] && !customElements.get('cart-items')) chain = chain.then(function () { return loadScript(srcs[0]); });
        if (srcs[1]) chain = chain.then(function () { return loadScript(srcs[1]); });
        return chain;
      })
      .then(function () {
        bagLoaded = true;
        bagDirty = false;
        if (window.Wrapped && typeof window.Wrapped.buildExtensions === 'function') {
          Promise.resolve(window.Wrapped.buildExtensions(true)).then(scheduleDecorate, scheduleDecorate);
        }
        bag.querySelectorAll('.lc-recos').forEach(recosUpdate);
      })
      .catch(function () {
        bagLoading = null;
        throw new Error('bag');
      });
    return bagLoading;
  }

  function syncBag() {
    if (!bagDirty || giftPending || queue.length || typeof window.lcCartRefresh !== 'function') return Promise.resolve();
    bagDirty = false;
    return window.lcCartRefresh().catch(function () {}).then(function () { refreshCounts(); });
  }

  function lockScroll() {
    scrollY0 = window.scrollY || 0;
    var b = document.body.style;
    b.position = 'fixed'; b.top = (-scrollY0) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
  }
  function unlockScroll() {
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    window.scrollTo(0, scrollY0);
  }

  var isOpen = false;
  function openBag(instant) {
    if (isOpen) return;
    isOpen = true;
    ensureBag();
    holdChat(true);
    lockScroll();
    bag.setAttribute('aria-hidden', 'false');
    if (instant) bag.classList.add('no-anim');
    var panel = bag.querySelector('.lc-bag__panel');
    panel.scrollTop = 0;
    void panel.offsetWidth;
    bag.classList.add('is-open');
    if (instant) setTimeout(function () { bag.classList.remove('no-anim'); }, 50);
    if (bagLoaded) {
      syncBag();
    } else {
      loadBag().then(syncBag, function () { window.location.href = root() + 'cart'; });
    }
  }

  function closeBag() {
    if (!bag || !isOpen) return;
    isOpen = false;
    bag.classList.remove('is-open');
    bag.setAttribute('aria-hidden', 'true');
    unlockScroll();
    holdChat(false);
  }
  window.lcOpenBag = openBag;
  window.lcCloseBag = closeBag;

  if (!window.__lcBagEarly) {
    window.__lcBagEarly = true;
    document.addEventListener('click', function (e) {
      if (!MQ_PHONE.matches || onCartPage()) return;
      var trigger = e.target.closest && e.target.closest('.header-cart-trigger');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      openBag(false);
    }, true);
  }

  document.addEventListener('show-minicart', function (e) {
    if (!MQ_PHONE.matches || onCartPage()) return;
    if (e.detail && e.detail.showmodal === false) return;
    e.stopImmediatePropagation();
    bagDirty = true;
    openBag(false);
  }, true);

  document.addEventListener('click', function (e) {
    if (!bag || !bag.contains(e.target)) return;
    var close = e.target.closest('.lc-cart-close, .end-continue-shop a, .end-continue-shop');
    if (!close) return;
    e.preventDefault();
    e.stopPropagation();
    closeBag();
  }, true);

  window.addEventListener('pagehide', function () {
    try { if (isOpen) sessionStorage.setItem('lcBagReopen', '1'); } catch (e) {}
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && isOpen) closeBag();
  });

  /* ==========================================================
     3. Bulle de discussion : pas de chevauchement avec les panneaux
     ========================================================== */
  var chatTimer = null;
  function holdChat(on) {
    clearTimeout(chatTimer);
    if (on) {
      document.documentElement.classList.add('lc-chat-hold');
    } else {
      chatTimer = setTimeout(function () { document.documentElement.classList.remove('lc-chat-hold'); }, 550);
    }
  }
  function watchMinicart() {
    var m = document.querySelector('.header-cart-modal');
    if (!m || !('MutationObserver' in window)) return;
    var was = m.classList.contains('opened');
    new MutationObserver(function () {
      var now = m.classList.contains('opened');
      if (now !== was) { was = now; if (!isOpen) holdChat(now); }
    }).observe(m, { attributes: true, attributeFilter: ['class'] });
  }
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('.header-cart-trigger')) holdChat(true);
  }, true);

  /* ==========================================================
     4. Carrousel "Vous aimerez aussi" : fleches (2 produits par clic, defilement doux)
     ========================================================== */
  function recosUpdate(sec) {
    if (!sec) return;
    var track = sec.querySelector('.lc-recos__track');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    var pos = track.__lcTarget != null ? track.__lcTarget : track.scrollLeft;
    sec.classList.toggle('has-overflow', max > 2);
    var prev = sec.querySelector('.lc-recos__btn[data-dir="-1"]');
    var next = sec.querySelector('.lc-recos__btn[data-dir="1"]');
    if (prev) prev.disabled = pos <= 2;
    if (next) next.disabled = pos >= max - 2;
  }
  window.lcRecosUpdate = recosUpdate;
  function easeInOut(k) { return k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2; }
  function glide(track, to) {
    var sec = track.closest('.lc-recos');
    var from = track.scrollLeft;
    var dur = 700;
    var start = null;
    track.__lcTarget = to;
    track.__lcAnim = (track.__lcAnim || 0) + 1;
    var id = track.__lcAnim;
    track.style.scrollSnapType = 'none';
    track.style.scrollBehavior = 'auto';
    recosUpdate(sec);
    function step(t) {
      if (id !== track.__lcAnim) return;
      if (start === null) start = t;
      var k = Math.min(1, (t - start) / dur);
      track.scrollLeft = from + (to - from) * easeInOut(k);
      if (k < 1) { requestAnimationFrame(step); return; }
      track.__lcTarget = null;
      track.style.scrollSnapType = '';
      track.style.scrollBehavior = '';
      recosUpdate(sec);
    }
    requestAnimationFrame(step);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.lc-recos__btn');
    if (!btn) return;
    var sec = btn.closest('.lc-recos');
    var track = sec && sec.querySelector('.lc-recos__track');
    var item = track && track.querySelector('.lc-recos__item');
    if (!item) return;
    e.preventDefault();
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var step = 2 * (item.getBoundingClientRect().width + gap);
    var max = track.scrollWidth - track.clientWidth;
    var base = track.__lcTarget != null ? track.__lcTarget : track.scrollLeft;
    var to = Math.max(0, Math.min(max, base + parseInt(btn.dataset.dir, 10) * step));
    glide(track, to);
  });
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('lc-recos__track') && t.__lcTarget == null) recosUpdate(t.closest('.lc-recos'));
  }, true);
  window.addEventListener('resize', function () { document.querySelectorAll('.lc-recos').forEach(recosUpdate); });

  /* ==========================================================
     Demarrage
     ========================================================== */
  function init() {
    disableWrappedReload();
    if (typeof window.updateNumberCartItems === 'function') {
      window.updateNumberCartItems = function () { refreshCounts(); };
    }
    getCart().then(function (cart) {
      annotateDrawer(cart);
      return cleanOrphans(cart).then(function (changed) {
        if (changed) return refreshMinicart().then(refreshCounts);
        setCounts(articleCount(cart));
      });
    }).catch(function () {});

    watchMinicart();
    watchDrawerTotal();
    document.querySelectorAll('.lc-recos').forEach(recosUpdate);

    if (MQ_PHONE.matches && !onCartPage()) {
      var reopen = false;
      try { reopen = sessionStorage.getItem('lcBagReopen') === '1'; sessionStorage.removeItem('lcBagReopen'); } catch (e) {}
      if (reopen || window.__lcBagPending) {
        window.__lcBagPending = false;
        openBag(reopen);
      } else {
        var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 800); };
        idle(function () { loadBag().catch(function () {}); });
      }
    }

    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var n = muts[i].target;
          if (n && n.closest && (n.closest('.giftbox-container') || n.closest('.header-cart-modal') || n.closest('#main-cart-items') || n.closest('#lc-bag'))) {
            scheduleDecorate();
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    decorateAll();
    window.addEventListener('load', function () {
      disableWrappedReload();
      scheduleDecorate();
      document.querySelectorAll('.lc-recos').forEach(recosUpdate);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();